import { DoorOpeningScreen } from "~/components/DoorOpeningScreen";

type Props = {
	unlockRequestId: string;
	onOpened: () => void;
	onClosed: () => void;
	onExit?: () => void;
};

export function PickUpOpeningPage({ unlockRequestId, onOpened, onClosed, onExit }: Props) {
	return <DoorOpeningScreen unlockRequestId={unlockRequestId} onOpened={onOpened} onClosed={onClosed} onExit={onExit} />;
}
